/*
Author: Atul Vasudevan
Story: ENT-2317
 */
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as _ from 'lodash';
import {BsModalService} from "ngx-bootstrap/modal";
import {RequestService} from "../../../../services/request/request.service";
import {AlertBannerService, AlertType} from "../../../../lib/alert-banner";
import {WarningModalContentComponent} from "../../../../lib/warning-modal/warning-modal.component";
import {PermissionsService} from '../../../../services/permissions/permissions.service';
import {AddBackgroundCheckModalComponent} from "../add-background-check-modal/add-background-check-modal.component";
import {ConstantsService} from "../../../../services/constants/constants.service";
import {OrganisationService} from "../../../../services/organisation/organisation.service";
import {
  TrustMarketplaceStatusService
} from "../../../../services/trust-marketplace-status/trust-marketplace-status.service";

@Component({
  selector: 'app-single-reference-recipient',
  templateUrl: './single-reference-recipient.component.pug',
  styleUrls: ['./single-reference-recipient.component.scss'],
  standalone: false
})
export class SingleReferenceRecipientComponent implements OnInit {

  @Input() recipient: any;
  @Input() typeOfCheck = 'references';
  @Input() componentOnModal: boolean = false;
  @Input() isReference = true;
  mobileIdFlows = [ConstantsService.ID_ONE_DOC_SHORT_NAME, ConstantsService.ID_TWO_DOCS_SHORT_NAME, ConstantsService.ID_ONE_DOC_DVS_SHORT_NAME, ConstantsService.ID_TWO_DOCS_DVS_SHORT_NAME];
  @Output() editEmitter = new EventEmitter();
  @Output() editStartedEmitter = new EventEmitter();
  @Output() editEndedEmitter = new EventEmitter();
  @Output() deleteEmitter = new EventEmitter();
  @Output() bcgEmit = new EventEmitter();
  private bsModalRef: any;
  editButtonText = $localize`Edit`;
  addButtonText = $localize`Add`;
  backgroundCheckTooltip = $localize`To enable background checks, you must connect to Trust Marketplace via account management.`
  backgroundRequestTooltip = '';
  dataToEdit = {};
  employmentTypeDropDownOptions = ConstantsService.EMPLOYMENT_TYPE

  id = -1;
  loading = false;

  isTrustApiConfigured = true;
  availableCheckNames: any[] = [];
  categorizedBackgroundCheckItems: any[] = [];
  items: any[] = [];
  backgroundChecks: any[] = [];
  checkedItems: any[] = [];
  role = ''
  hiringOrganisation = ''
  employmentSector = '';
  directorshipCountry = '';
  employmentType = '';
  trust1101Centric = false;
  // Under Centric, Credential & Education checks no longer expose a flow
  // (Highest level vs Specific quantity) selection - TRUST-1175.
  centricNoFlowChecks = [ConstantsService.CV_SHORT_NAME, ConstantsService.EDUV_SHORT_NAME];
  icrcBackgroundCheck = ConstantsService.ICRC_SHORT_NAME;
  CD_SPRINT_24_02 = false;
  tmpAdminStatus: number | undefined = 1;
  canSendBackgroundRequest = false;
  fuzziness = 'Exact match'
  birth_year = "";
  selectedCodes: any = [];
  middleName = ''
  employmentCoverage = '5'
  verificationEmpMin = '2'
  verificationEmpMax = '3'
  verificationQualMin = '1'
  verificationQualMax = '3'
  verificationCredMin = '1'
  verificationCredMax = '3'
  cvsqBackgroundCheck = ConstantsService.CV_SQ_SHORT_NAME;
  cvhlBackgroundCheck = ConstantsService.CV_HL_SHORT_NAME;
  edusqBackgroundCheck = ConstantsService.EDUV_SQ_SHORT_NAME;
  eduhlBackgroundCheck = ConstantsService.EDUV_HL_SHORT_NAME;
  empsqBackgroundCheck = ConstantsService.EMPV_SQ_SHORT_NAME;
  empcpBackgroundCheck = ConstantsService.EMPV_CP_SHORT_NAME;

  flowAddtionalFieldsMapping = {
    [this.cvsqBackgroundCheck]: ['verification_cred_min', 'verification_cred_max'],
    [this.edusqBackgroundCheck]: ['verification_qual_min', 'verification_qual_max'],
    [this.empsqBackgroundCheck]: ['verification_emp_min', 'verification_emp_max'],
    [this.empcpBackgroundCheck]: ['verification_years'],
  };
  flowNoAddtionalFieldsMapping = {
    [this.cvhlBackgroundCheck]: ConstantsService.CV_SHORT_NAME,
    [this.eduhlBackgroundCheck]: ConstantsService.EDUV_SHORT_NAME,
  };
  constructor(private modalService: BsModalService,
              private requestService: RequestService,
              private organisationService: OrganisationService,
              private alertList: AlertBannerService,
              private trustMarketplaceStatusService: TrustMarketplaceStatusService,
              private permissions: PermissionsService) {
  }

  ngOnInit(): void {
    this.trust1101Centric = this.permissions.isFeatureActivated('trust-1101-centric');
    this.canSendBackgroundRequest = this.permissions.hasPermission('can_send_backgroundcheck_requests')
    if(this.canSendBackgroundRequest){
      this.retrieveAvailableBackgroundChecks();
    }
    this.fetchTrustMarketplaceStatus();
    this.backgroundRequestTooltip = !this.canSendBackgroundRequest ? ConstantsService.BACKGROUND_CHECK_NONE_TOOLTIP : '';
  }

  fetchTrustMarketplaceStatus() {
    this.trustMarketplaceStatusService.trustStatus$.subscribe(
      status_code => {
        this.isTrustApiConfigured = status_code === 3;
        this.backgroundCheckTooltip = this.isTrustApiConfigured ? '' : this.backgroundCheckTooltip

      }, error => {
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
    );
      this.trustMarketplaceStatusService.trustAdminStatus.subscribe(
        res => {
          if (res != undefined) {
            this.tmpAdminStatus = res;
          }
        }, error => {
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      );
  }

  editRecipient(recipient) {
    this.id = recipient['id'];
    this.dataToEdit = {
      "draftUid": localStorage.getItem('draft_reference_uid'),
      "recipient": recipient
    };
    this.editStartedEmitter.emit();
  }

  editRecipientDetails(recipientToEdit) {
    this.loading = true;
    let isExternal = false
    if(!this.isReference){
        isExternal = true
    }
      this.requestService.editBackgroundChecks(recipientToEdit['recipient'], localStorage.getItem('draft_reference_uid'), undefined, isExternal).subscribe((data: any) => {
        this.editEmitter.emit(data)
        this.loading = false
      },
      (err: any) => {
        console.log(err);
        this.loading = false
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  deprecatedEditRecipientDetails(recipientToEdit) {
    this.requestService.deprecatedEditReference(recipientToEdit['recipient'], localStorage.getItem('draft_reference_uid')).subscribe((data: any) => {
        this.editEmitter.emit(data)
        this.loading = false
      },
      (err: any) => {
        console.log(err);
        this.loading = false
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  deleteRecipient(event) {
    let initialState = {
      "title": $localize`Remove recipient`,
      "message": $localize`Do you want to continue?`
    };
    this.bsModalRef = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered', initialState
    });
    this.bsModalRef.content.selection.subscribe(res => {
      if (res === true) {
        this.loading = true;
           this.requestService.removeBackgroundCheck(localStorage.getItem('draft_reference_uid'), event['id'], undefined, false).subscribe((data: any) => {
            this.deleteEmitter.emit(data)
            this.loading = false;
          },
          (err: any) => {
            console.log(err);
            this.loading = false;
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          })

      }
    })
  }

  deprecatedDeleteRecipient(event) {
    this.requestService.deprecatedRemoveReference(localStorage.getItem('draft_reference_uid'), event['id']).subscribe((data: any) => {
        this.deleteEmitter.emit(data)
        this.loading = false;
      },
      (err: any) => {
        console.log(err);
        this.loading = false;
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  setBackgroundCheck() {
    // Get background check names based on short_names
    this.availableCheckNames = Object.keys(this.recipient?.checks || {}).map(shortName => {

      let check = this.categorizedBackgroundCheckItems.find(check => check.short_name === shortName);
      if(check && check?.flow && check.checked){
          const selectedFlow = check.flow.find(flowItem => flowItem.checked === true);
          return selectedFlow ? `${check.name} (${selectedFlow.name})` : check.name;
      }
      check = this.backgroundChecks.find(check => check.short_name === shortName);
      return check ? check.name : '';
    });

    this.availableCheckNames = this.availableCheckNames.filter(name => name !== '');
    // Join check names to display selected checks on view
    this.recipient.backgroundCheck = this.availableCheckNames ? this.availableCheckNames.join(', ') : '';
    this.checkedItems = this.categorizedBackgroundCheckItems.filter(item2 => {
      const match = Object.keys(this.recipient?.checks).some(short_name => short_name === item2.short_name);
      if (match) {
        item2.checked = true;
      }
      return match;
    });

    if (this.recipient.checks?.acic?.role) {
      this.role = this.recipient.checks?.acic?.role
    }
    if (this.recipient.checks?.ukdbsc?.role) {
      this.role = this.recipient.checks?.ukdbsc?.role
    }
    if (this.recipient.checks?.acic?.hiring_organisation) {
      this.hiringOrganisation = this.recipient.checks?.acic?.hiring_organisation
    }
    if (this.recipient.checks?.ukdbsc?.employment_sector) {
      this.employmentSector = this.recipient.checks?.ukdbsc?.employment_sector
    }
    if (this.trust1101Centric && this.recipient.checks?.[this.icrcBackgroundCheck]?.role) {
      this.role = this.recipient.checks?.[this.icrcBackgroundCheck]?.role
    }
    if (this.trust1101Centric && this.recipient.checks?.[this.icrcBackgroundCheck]?.employment_sector) {
      this.employmentSector = this.recipient.checks?.[this.icrcBackgroundCheck]?.employment_sector
    }

    if (this.recipient.checks?.ncc_police_check?.reason) {
      this.role = this.recipient.checks?.ncc_police_check?.reason
    }
    if (this.recipient.checks?.ncc_police_check?.place_work) {
      this.hiringOrganisation = this.recipient.checks?.ncc_police_check?.place_work
    }
    if (this.recipient.checks?.ncc_police_check?.type) {
      this.employmentType = this.recipient.checks?.ncc_police_check?.type
    }

    if (this.recipient.checks?.credential_verification?.verification_cred_min) {
      this.verificationCredMin = this.recipient.checks?.credential_verification?.verification_cred_min
    }
    if (this.recipient.checks?.credential_verification?.verification_cred_max) {
      this.verificationCredMax = this.recipient.checks?.credential_verification?.verification_cred_max
    }
    if (this.recipient.checks?.education_verification?.verification_qual_min) {
      this.verificationQualMin = this.recipient.checks?.education_verification?.verification_qual_min
    }
    if (this.recipient.checks?.education_verification?.verification_qual_max) {
      this.verificationQualMax = this.recipient.checks?.education_verification?.verification_qual_max
    }
    if (this.recipient.checks?.employment_verification?.verification_emp_min) {
      this.verificationEmpMin = this.recipient.checks?.employment_verification?.verification_emp_min
    }
    if (this.recipient.checks?.employment_verification?.verification_emp_max) {
      this.verificationEmpMax = this.recipient.checks?.employment_verification?.verification_emp_max
    }
    if (this.recipient.checks?.employment_verification?.verification_years) {
      this.employmentCoverage = this.recipient.checks?.employment_verification?.verification_years
    }
    this.birth_year = '';
    this.fuzziness = 'Exact match';
    this.middleName = '';
    if (this.recipient.checks?.aml?.birth_year) {
        this.birth_year = this.recipient.checks?.aml?.birth_year
    }
    if (this.recipient.checks?.aml?.fuzziness) {
        // Convert from API key format (e.g., "0") to display value format (e.g., "0%")
        const fuzzinessKey = this.recipient.checks?.aml?.fuzziness;
        const fuzzinessOption = ConstantsService.FUZZINESSOPTIONS.find(opt => opt.key === fuzzinessKey);
        this.fuzziness = fuzzinessOption?.value || 'Exact match';
    }
    // Convert from array of strings (e.g., ["AF"]) to full country objects with name, value, checked
    const countryCodes = this.recipient.checks?.aml?.country_codes;
    if (Array.isArray(countryCodes) && countryCodes.length > 0) {
        // Check if it's already in object format or string format
        if (typeof countryCodes[0] === 'string') {
            // Look up country name from COUNTRY_ALPHA_CODES and build full object
            this.selectedCodes = countryCodes.map(code => {
                const country = ConstantsService.COUNTRY_ALPHA_CODES.find(c => c.value === code);
                return country ? {name: country.name, value: country.value, checked: true} : {
                    value: code,
                    checked: true
                };
            });
        } else {
            // Already in object format
            this.selectedCodes = countryCodes;
        }
    } else {
        this.selectedCodes = [];
    }
    // Extract middle_name from aml or banned_persons
    if (this.recipient.checks?.aml?.middle_name) {
        this.middleName = this.recipient.checks?.aml?.middle_name
    } else if (this.recipient.checks?.banned_persons?.middle_name) {
        this.middleName = this.recipient.checks?.banned_persons?.middle_name
    }
    this.directorshipCountry = this.recipient.checks?.[ConstantsService.DIRECTORSHIP_CHECK_SHORT_NAME]?.country || '';
  }


  avatarInitials(person: { first_name?: string | null; last_name?: string | null } | null): string {
    const first = (person?.first_name || '').charAt(0);
    const last = (person?.last_name || '').charAt(0);
    return `${first}${last}`;
  }

  recipientDisplayName(person: { first_name?: string | null; last_name?: string | null } | null): string {
    return [person?.first_name, person?.last_name].filter(Boolean).join(' ');
  }

  checkClass(recipient, fields) {
    for (let field of fields) {
      if (recipient.meta.error_fields.indexOf(field) != -1) {
        return 'error-recipients';
      } else if (recipient.meta.warning_fields.indexOf(field) != -1) {
        return 'warning';
      }
    }
    return '';
  }

  closeEvent() {
    this.id = -1;
    this.editEndedEmitter.emit();
  }

  addEditBackgroundCheck(headingText) {

    this.setCheckedItems();
    const employmentType = this.employmentTypeDropDownOptions.find(type => type.key === this.employmentType);
    const employmentValue= this.employmentTypeDropDownOptions.find(type => type.value === this.employmentType);
    this.employmentType = employmentType ? employmentType.value : '';

    if(this.employmentType==''){
      this.employmentType = employmentValue ? employmentValue.value : '';
    }
    this.bsModalRef = this.modalService.show(AddBackgroundCheckModalComponent, {

    class: 'modal-dialog-centered background-popup',
    initialState: {
      headingText: headingText,
      receipientId: this.recipient.id,
      selectedItems: _.cloneDeep(this.checkedItems),
      countryItems: _.cloneDeep(ConstantsService.COUNTRY_ALPHA_CODES),
      items: _.cloneDeep(this.categorizedBackgroundCheckItems),
      role: this.role,
      hiringOrganisation: this.hiringOrganisation,
      country: this.directorshipCountry,
      employmentSector: this.employmentSector,
      employmentValue: this.employmentType,
      isEdit: !!this.recipient.backgroundCheck,
      birth_year: this.birth_year,
      fuzziness: this.fuzziness,
      selectedCodes: _.cloneDeep(this.selectedCodes),
      middleName: this.middleName,
      employmentCoverage: this.employmentCoverage,
      verificationEmpMin: this.verificationEmpMin,
      verificationEmpMax: this.verificationEmpMax,
      verificationQualMin: this.verificationQualMin,
      verificationQualMax: this.verificationQualMax,
      verificationCredMin: this.verificationCredMin,
      verificationCredMax: this.verificationCredMax,

    },
    ignoreBackdropClick: true
    });

    this.bsModalRef?.content.onSave.subscribe((result) => {
    this.availableCheckNames = Object.keys(result.data).map(shortName => {

        const checkItem = result.items.find(item => item.short_name === shortName);
        if (!checkItem) {
            const check = this.backgroundChecks.find(check => check.short_name === shortName);
            return check ? check.name : ''
        }

        if (checkItem?.flow && checkItem.checked) {
            const selectedFlow = checkItem.flow.find(flowItem => flowItem.checked === true);
            return selectedFlow ? `${checkItem.name} (${selectedFlow.name})` : checkItem.name;
        }
        return checkItem?.name || '';
    });
    this.availableCheckNames = this.availableCheckNames.filter((name: any) => !!name && name !== '');
    this.recipient.backgroundCheck = this.categorizedBackgroundCheckItems ? this.availableCheckNames.join(', ') : '';
    this.role = result.role;
    this.hiringOrganisation = result.hiring_organisation;
    this.directorshipCountry = result.country;
    this.employmentSector = result.employment_sector;
    this.employmentType = result.employment_type;
    this.birth_year = result.birth_year;
    this.fuzziness = result.fuzziness;
    this.selectedCodes = result.country_codes;
    this.middleName = result.middle_name;
    this.employmentCoverage = result.employmentCoverage;
    this.verificationEmpMin = result.verificationEmpMin;
    this.verificationEmpMax = result.verificationEmpMax;
    this.verificationQualMin = result.verificationQualMin;
    this.verificationQualMax = result.verificationQualMax;
    this.verificationCredMin = result.verificationCredMin;
    this.verificationCredMax = result.verificationCredMax;
    this.items = result.items
    this.bcgEmit.emit(true);
    });
  }

  retrieveAvailableBackgroundChecks(checkName = '') {
    this.loading=true;
    this.requestService.getEnhancedBackgroundChecksList().subscribe(
      (data: any) => {
        this.backgroundChecks = this.checksVisibleForTrust1337(data?.data['background_checks']);
        this.categorizedBackgroundCheckItems = this.categorizeChecksByFlow(this.backgroundChecks);
        this.setBackgroundCheck();
        this.loading=false;
      },
      (error: any) => {
        console.log("error", error);
      }
    );

  }

  setCheckedItems(){
    if(this.items.length){
        this.categorizedBackgroundCheckItems.forEach(item2 => {
            const match = this.items.find(
                item1 => item1.short_name === item2.short_name && item1.checked != item2.checked
            );
            if (match) {
                Object.assign(item2, match);
            }
        });
    }
    this.checkedItems = this.categorizedBackgroundCheckItems.filter(item2 => {
      if (item2.short_name === 'mobile_id') {
        let flowIndex = -1;
        let flowName = '';

        for (let index = 0; index < item2.flow.length; index++) {
          const flow = item2.flow[index];
          const flowNameMatch = this.availableCheckNames.includes(flow.name);
          flow.checked = flowNameMatch;
          if (flowNameMatch) {
            flowIndex = index;
            flowName = flow.name;
          }
        }
        item2.selectedFlowName = flowName;
        item2.selectedFlow = flowIndex;
        item2.checked = flowName !== '';
        return flowName !== '';
      } else {
          if(this.items.length){
              const match = this.items.find(item1 => item1.short_name === item2.short_name && item1.checked);
              if(match){
                  return match ? true : false;
              }
          }
          else if(item2?.flow?.length && item2.checked){
              return true
          }
          const match = this.availableCheckNames.some(item1 => item1 === item2.name);
          item2.checked = match;
          return match;

      }
    });
  }

  getBackgroundCheckType(checkData: any, short_name): string | null {
      if (!checkData || typeof checkData !== 'object' || Object.keys(checkData).length === 0) {
          // return this.flowNoAddtionalFieldsMapping.short_name;
          const entry = Object.entries(this.flowNoAddtionalFieldsMapping)
            .find(([_, v]) => v === short_name);
          return entry ? entry[0] : null;
      }

      for (const [mappingKey, requiredFields] of Object.entries(this.flowAddtionalFieldsMapping)) {

        const hasAllFields = requiredFields.every(field => field in checkData);
        if (hasAllFields) {
          return mappingKey;
        }
      }

      return null;
    }

  private checksVisibleForTrust1337(checks: any[] = []) {
    return (checks || []).filter(check => {
      if (check.short_name === ConstantsService.AU_ENHANCED_PUBLIC_RECORD_CHECK_SHORT_NAME) {
        return this.permissions.isFeatureActivated('trust-1337-directorship-credit-checks');
      }
      if (check.short_name === ConstantsService.DIRECTORSHIP_CHECK_SHORT_NAME) {
        return this.permissions.isFeatureActivated('trust-1337-directorship-credit-checks');
      }
      return true;
    });
  }

  categorizeChecksByFlow(checks: any[]): any[] {
    const categorizedChecks: any[] = [];
    const mobileIdCheck = {
      "uid": "12345",
      "short_name": "mobile_id",
      "name": "MobileID",
      "provider_name": "RapidID",
      "config": {}
    };
    let matchedFlows: any[] = [];
    let uniqueRegions = new Set<string>();
    let uniqueCategories = new Set<string>();

    checks.forEach(check => {
      if (this.mobileIdFlows.includes(check.short_name)) {
        check.checked = false;
        matchedFlows.push(check);
        check.config.regions.forEach(region => uniqueRegions.add(region));
        check.config.categories.forEach(category => uniqueCategories.add(category));
      } else {
          let flow_check = {
              name: check.name,
              vendor: check.provider_name,
              region: check.config.regions[0],
              short_name: check.short_name
          }
          if(check.config.flows){
              const { xref_open_api, ...recipientChecks } = this.recipient?.checks || {};
              const isSelected = !!(this.recipient && recipientChecks?.[check.short_name]);

              // Centric Credential/Education: no flow UI — treat as a plain parent check.
              if (this.trust1101Centric && this.centricNoFlowChecks.includes(check.short_name)) {
                  if (isSelected) {
                      flow_check['checked'] = true;
                  }
              } else {
                  flow_check['flow'] = _.cloneDeep(check.config.flows)
                  if(isSelected){
                      const recipientCheckData = recipientChecks[check.short_name]
                      flow_check['checked'] = true
                      const flowMatched = this.getBackgroundCheckType(recipientCheckData, check.short_name)
                      const index = check.config.flows.findIndex(
                          (flow: any) => flow.short_name === flowMatched
                      );
                      if (index !== -1) {
                          flow_check['flow'][index] = {
                              ...flow_check['flow'][index],
                              checked: true
                          };

                          const { name } = flow_check['flow'][index];
                          flow_check['selectedFlowName'] = name
                          flow_check['selectedFlow'] = index
                      }

                  }
              }
          }
          categorizedChecks.push(flow_check);
      }
    });

    // Add MobileID check with it's flows (All ID checks)
    if (matchedFlows.length > 0) {
      const formattedMobileIdCheck = {
        ...mobileIdCheck,
        flow: matchedFlows,
        checked: false,
        config: {
          regions: Array.from(uniqueRegions),
          categories: Array.from(uniqueCategories)
        }
      };
      categorizedChecks.push(formattedMobileIdCheck);
    }

    return categorizedChecks;
  }

  getBackgroundCheckTooltip() {
    if (!this.isTrustApiConfigured) {
      return $localize`To enable background checks, you must first connect to Trust Marketplace within the organisation settings.`
    } else if (this.isTrustApiConfigured && !this.canSendBackgroundRequest) {
      return this.backgroundRequestTooltip
    } else if (this.isTrustApiConfigured && this.canSendBackgroundRequest) {
      return '';
    }
    return ''
  }
}
